import { GqlClient, GqlClientOptions } from '@search/gql-client/src';
import { gql2CreateCachedFetcher } from '@search/gql-client/src/useGql2';
import { GeoUserRegion } from '../GeoUserRegion';
import { GeoRootRegionRepository } from '../GeoRootRegionRepository';
import { createClGeoSlugsFetcher } from '../clGeoSlugsQuery/clGeoSlugsQuery';
import { clGeoRootRegionQuery$data as clGeoRootRegionQueryResponse, clGeoRootRegionQuery$variables as clGeoRootRegionQueryVariables } from './__generated__/clGeoRootRegionQuery.graphql';
import { clGeoRootRegionQuery } from './clGeoRootRegionQuery';

function createclGeoRootRegionFetcher({ gql }: {
    gql: GqlClient;
}) {
    return (vars: clGeoRootRegionQueryVariables, opts?: GqlClientOptions) => {
        return gql.client<
            clGeoRootRegionQueryVariables,
            clGeoRootRegionQueryResponse
        >(clGeoRootRegionQuery, vars, opts);
    };
}

const cachePrefix = 'clGeoRootRegion';

function createclGeoRootRegionFetcherCached({ gql }: {
    gql: GqlClient;
}) {
    const fetcher = createclGeoRootRegionFetcher({ gql });

    return gql2CreateCachedFetcher({ fetcher, cachePrefix, gql });
}

export function clGeoRootRegionRepositoryLoad(
    {
        gql,
        appType = 'CLASSIFIED',
        rawCookie,
        geoIds
    }: Partial<clGeoRootRegionQueryVariables> & {
        gql: GqlClient;
        geoIds?: readonly string[];
        rawCookie?: string;
    }
) {
    const clGeoSlugsFetcher = createClGeoSlugsFetcher({ gql });
    const fetcher = createclGeoRootRegionFetcherCached({ gql });

    const { userRegionId } = new GeoUserRegion({ rawCookie });

    return Promise.all([
        fetcher({ appType, suggestedGeoId: String(userRegionId ?? 3), skipGeo: ! userRegionId }),
        geoIds ? clGeoSlugsFetcher({ geos: geoIds.map(id => ({ smart: id })) }) : undefined
    ])
        .then(([ resp, slugsResp ]) => {
            const rootRegions = new GeoRootRegionRepository(resp);

            slugsResp?.data?.geo2.items.forEach(geo => {
                if (geo.__typename === 'GeoObject') {
                    rootRegions.slugs.add(geo, 3);
                }
            });

            return rootRegions;
        })
        .catch(err => new GeoRootRegionRepository({ errors: [ err ] }));
}
